module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-supervisors",
    attrs: {
      "data-infinite-scroll": ""
    }
  }, [_c('panel-search', {
    staticClass: "panel-search-light",
    attrs: {
      "placeholder": "Введите фио, телефон или почту для поиска"
    },
    on: {
      "search": _vm.search
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.supervisors), function(supervisor) {
    return _c('tr', [_c('td', [_c('a', {
      attrs: {
        "href": ("/supervisors/" + (supervisor.id))
      }
    }, [_vm._v(_vm._s(supervisor.full_name))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s((supervisor.salon) ? supervisor.salon.name : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(supervisor.login))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(supervisor.phone))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(supervisor.email))]), _vm._v(" "), (supervisor.start_salon) ? _c('td', [_vm._v(_vm._s(_vm._f("date_format")(supervisor.start_salon, 'DD.MM.YYYY HH:mm')))]) : _c('td'), _vm._v(" "), (supervisor.end_salon) ? _c('td', [_vm._v(_vm._s(_vm._f("date_format")(supervisor.end_salon, 'DD.MM.YYYY HH:mm')))]) : _c('td')])
  }))]), _vm._v(" "), (_vm.next_page_url) ? _c('button', {
    staticClass: "load-more",
    on: {
      "click": _vm.loadNextPage
    }
  }, [_vm._v("Еще")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ФИО")]), _vm._v(" "), _c('th', [_vm._v("Привязанный салон")]), _vm._v(" "), _c('th', [_vm._v("Логин")]), _vm._v(" "), _c('th', [_vm._v("Телефон")]), _vm._v(" "), _c('th', [_vm._v("E-mail")]), _vm._v(" "), _c('th', [_vm._v("Работ. с")]), _vm._v(" "), _c('th', [_vm._v("Уволен")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1dffebdb", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1dffebdb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/ListSupervisors.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-1dffebdb"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/ListSupervisors.vue
// module chunks = 0